// AUTHORITATIVE TradeRepository (NO DEMO, NO FIRESTORE)
import { loadImportedTrades } from '../../utils/importedTradesStorage';
import { loadPersistedCsvTrades, mergePersistedCsvTradesWithLocalTrades } from '../import-engine/persistedCsvTradeRead';
import { loadCustomTrades, sortTradesNewestFirst } from './authoritativeTradeData';
import { normalizeVisibleTradeIds } from './visibleTradeIds';

/**
 * The canonical authoritative trade collection: local imported trades, server
 * persisted CSV trades, and Journal custom/manual trades, deduplicated and
 * normalized. Every trade-driven page (Trades, Calendar, Journal, Trends,
 * Dashboard) and every trade-derived widget must source from this same
 * repository so a mutation in one consumer is visible in all of them.
 */
export async function loadTrades(options: { resume?: boolean; onProgress?: (trades: any[]) => void } = {}) {
  const localTrades = loadImportedTrades();
  const customTrades = loadCustomTrades();

  const mergeAndNormalize = (persistedTrades: any[], partial: boolean) => {
    const merged = mergePersistedCsvTradesWithLocalTrades(
      [...(Array.isArray(localTrades) ? localTrades : []), ...(Array.isArray(customTrades) ? customTrades : [])],
      persistedTrades,
      { persistedReadVerified: true, persistedReadPartial: partial }
    );
    return normalizeVisibleTradeIds(sortTradesNewestFirst(merged)).records;
  };

  try {
    const persistedTrades = await loadPersistedCsvTrades({
      forceRefresh: true,
      resume: Boolean(options.resume),
      onProgress: options.onProgress ? (partial) => options.onProgress?.(mergeAndNormalize(partial, true)) : undefined,
    });
    return mergeAndNormalize(persistedTrades, false);
  } catch (error) {
    // A local-only fallback would look like a complete account history to callers
    // that calculate totals, numbering, or delete targets from this collection.
    throw error;
  }
}
